import {
  isRevSharePricing,
  isTiersPricing,
  isPerUnitPricing,
  isTieredSubscriptionPricing
} from '@vy/services';
import type { ProductVariant } from '@vy/types';
import { USAGE_PRICING_OPTIONS } from '../../../../../utils/types/usage-pricing-options';
import { raise } from '@vy/utils';

export function getPricingTypeLabel(variant: ProductVariant) {
  if (isRevSharePricing(variant.pricing)) {
    return USAGE_PRICING_OPTIONS.REVENUE_SHARE;
  }

  if (isTiersPricing(variant.pricing)) {
    return USAGE_PRICING_OPTIONS.TIERS;
  }

  if (isPerUnitPricing(variant.pricing)) {
    return USAGE_PRICING_OPTIONS.PER_UNIT;
  }

  if (isTieredSubscriptionPricing(variant.pricing)) {
    return USAGE_PRICING_OPTIONS.TIERED_SUBSCRIPTION;
  }

  return raise(`Unknown pricing type: ${variant.pricing}`);
}
